var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_vm._v(" "+_vm._s(_vm.lastDigitsChaveAcesso)+" "),_c('v-btn',{attrs:{"icon":"","left":"","small":""},on:{"click":_vm.copyChaveAcesso}},[_c('v-icon',{attrs:{"small":""}},[_vm._v("mdi-content-copy")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }